import { loggedType } from './loggedType';

const loggedIn = () => ({ type: loggedType.LOGGED_IN });
const loggedOut = () => ({ type: loggedType.LOGGED_OUT });

export { loggedIn, loggedOut };